module.exports = __webpack_public_path__ + "media/images/ADC_Logo_FC-4ee5606e9686569e37eeb125c332eace.png";